import IconCross from "../../icons/IconCross";

export default function SystemMessageContent({ onClose }: { onClose: () => void }) {
  return (
    <div>
      <div className="flex justify-between items-center p-4 border-b border-solid">
        <p className="text-base font-medium text-default-900">پیام سیستم</p>
        <IconCross width={22} height={22} className="text-light-400 cursor-pointer" onClick={() => onClose()} />
      </div>

      <div className="p-4">

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div className="flex-1 flex flex-col justify-center">
            <p className="text-sm text-light-400 mt-4 md:px-5">حداکثر 3 کالا قابل مقایسه است.</p>
          </div>
        </div>
      </div>
    </div>
  )
}